"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.polyyeld = void 0;
exports.polyyeld = {
    masterchef: "0x2DC11B394BD0f1CC6AC0a269cfe3CC0b333601B4",
};
